import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.$el = this.el
        this.$toggler = this.$('toggle')[0];
        this.$content = this.$('content')[0];
        this.events = {
            click: {
                'toggle' : 'open',
                'toggleOverlay' : 'toggleOverlay'
            }
        }
    }

    open(e) {
       if (this.$content.classList.contains('cs-is-open')) {
           this.closeCS();
       } else {
           this.openCS();
       }

    }

    openCS() {
        this.closeCS();
        this.$content.classList.add('cs-is-open');
    }

    toggleOverlay() {
        this.closeCS();
    }

    closeCS() {
        const elSelected = document.querySelectorAll(".cs-is-open");
        elSelected.forEach(el => {
            el.classList.remove('cs-is-open');
        });
    }
}
